import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import VueClickAway from 'vue3-click-away';
import Offer from './Offer.vue';

export const initOfferVue = () => {
  if (!document.getElementById('offer-app')) {
    return;
  }

  const app = createApp(Offer);

  app.config.$companySiteName = window.COMPANY_SITE_NAME;
  app.config.$companyPhone = window.COMPANY_PHONE;
  app.config.productionTip = false;

  const routes = [
    {
      path: '/offers',
      name: 'offer',
      component: Offer,
    },
  ];

  const router = createRouter({
    routes,
    history: createWebHistory(),
  });

  app.use(router);
  app.use(VueClickAway);
  app.mount('#offer-app');
};
